import React, { ReactNode, useMemo } from 'react';

import { Box, Stack } from '@mui/material';

import { useThemeMode } from '../../providers';

import { BulbImage } from './BulbImage';
import { HeartImage } from './HeartImage';
import { KeyImage } from './KeyImage';
import { TranscriptImage } from './TranscriptImage';

export const StyledSelectContainer = ({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: VoidFunction;
  children: ReactNode;
}) => {
  const { themeMode } = useThemeMode();

  const bgColor = useMemo(() => {
    if (active) {
      return 'primary.main';
    }
    if (themeMode === 'light') {
      return 'grey.100';
    }

    return 'grey.700';
  }, [active, themeMode]);

  return (
    <Box
      onClick={onClick}
      width={26}
      height={26}
      borderRadius="50%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      border="1px solid"
      borderColor={active ? (theme) => theme.palette.primary.main : (theme) => theme.palette.grey[400]}
      sx={{
        svg: {
          fill: active ? (theme) => theme.palette.grey[100] : (theme) => theme.palette.grey[400],
        },
        backgroundColor: bgColor,
        borderRadius: '50%',
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: active ? (theme) => theme.palette.primary.main : (theme) => theme.palette.primary.light,
          borderColor: active ? (theme) => theme.palette.primary.main : (theme) => theme.palette.primary.light,

          svg: {
            fill: (theme) => theme.palette.grey[100],
          },
        },
      }}
    >
      {children}
    </Box>
  );
};

export const TranscriptButtons = ({
  activeTranscription,
  onSetActiveTranscription,
}: {
  activeTranscription: number;
  onSetActiveTranscription: (value: number) => void;
}) => {
  return (
    <Stack spacing={3} direction="row" mb={3}>
      <StyledSelectContainer active={activeTranscription === 0} onClick={() => onSetActiveTranscription(0)}>
        <TranscriptImage />
      </StyledSelectContainer>
      <StyledSelectContainer active={activeTranscription === 1} onClick={() => onSetActiveTranscription(1)}>
        <BulbImage />
      </StyledSelectContainer>
      <StyledSelectContainer active={activeTranscription === 2} onClick={() => onSetActiveTranscription(2)}>
        <HeartImage />
      </StyledSelectContainer>
      <StyledSelectContainer active={activeTranscription === 3} onClick={() => onSetActiveTranscription(3)}>
        <KeyImage />
      </StyledSelectContainer>
    </Stack>
  );
};
